import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import lang from './lang';

export const fallbackLang = 'it';

const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage']
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: DETECTION_OPTIONS,
    ns: ['translation', 'faq'],
    defaultNS: 'translation',
    fallbackLng: fallbackLang,
    interpolation: {
      escapeValue: false
    },
    resources: {
      ...lang
    }
  });

export default i18n;
